import { MidmarketCheckout, ExpressCheckout, directMonthly } from '../../../settings';
export default {
    isSelfServiced: (state) => state.isSelfServiced,
    isENT: (state) => state.isENT,
    checkoutType: (state) => state.checkoutType,
    currencyIsoCode: (state) => state.currencyIsoCode,
    selectedDiscount: (state) => state.selectedDiscount,
    isExistingCustomer: (state) => state.isExistingCustomer,
    accountId: (state) => state.accountId,
    opptyId: (state) => state.opptyId,
    userEmail: (state) => state.userEmail,
    source: (state) => state.source,
    checkoutCompleted: (state) => state.checkoutCompleted,
    activePaymentProcessing: (state) => state.activePaymentProcessing,
    licenseTerm: (state) => state.licenseTerm,
    smallFleetOpportunity: (state) => state.smallFleetOpportunity,
    firstPurchase: (state) => state.firstPurchase,
    selectedPaymentType: (state) => state.selectedPaymentType,
    paymentMethod: (state) => state.paymentMethod,
    isDelinquent: (state) => state.isDelinquent,
    isPmUpdate: (state) => state.isPmUpdate,
    isMicro: (state) => state.isMicro,
    lastFour: (state) => state.lastFour,
    isDeferred: (state) => state.isDeferred,
    segment: (state) => state.segment,
    isRenewal: (state) => state.isRenewal,
    safetyEventReview: (state) => state.safetyEventReview,
    sentPaymentTypeErrorEmail: (state) => state.sentPaymentTypeErrorEmail,
    licenseStartDate: (state) => state.licenseStartDate,
    initialPaymentTerm: (state) => state.initialPaymentTerm,
    displayNACableSelection: (state) => {
        return ['USD', 'CAD'].includes(state.currencyIsoCode);
    },
    approvedPaymentType: (state) => state.approvedPaymentType,
    hideLicenses: (state) => state.hideLicenses,
    hasContractExpired:(state)=>state.hasContractExpired,
    creditLimit: (state) => state.creditLimit,
    creditLimitExceeded:(state, getters, rootState) => {
        if (state.checkoutType === ExpressCheckout || !state.creditLimit) {
            return false
        } else if (state.checkoutType === MidmarketCheckout &&
            state.isSelfServiced &&
            state.selectedPaymentType === directMonthly && 
            rootState.shoppingCart.productCostsInfo.subtotals.software.monthly > state.creditLimit) {
            return true
        } else {
            return false
        }
    },
    contract: (state) => state.contract,
    showContractDisclaimer: (state) =>  state.contract.isContractOnFile,
    safetyEventReviewPrice: (state) => state.safetyEventReviewPrice, 
    renewalTerm: (state) => state.renewalTerm,
    writtenLanguage: (state)=> state.writtenLanguage,
    isArcadian: (state)=> state.isArcadian,
    autoRenewalOptOut: (state)=> state.autoRenewalOptOut,
}
